var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfographics4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 618.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 118.05,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,118.05h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 118.05,
    width: 54.27,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,118.05h28.78c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-28.78c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 189.67,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,189.67h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 189.67,
    width: 98.03,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,189.67h72.7c6.98,0,12.62,5.65,12.62,12.62s-5.64,12.62-12.62,12.62h-72.7c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 404.54,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,404.54h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 404.54,
    width: 43.75,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,404.54h18.18c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-18.18c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 476.17,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,476.17h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 476.17,
    width: 25.24,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,476.17c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62-12.62-5.65-12.62-12.62,5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 547.79,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,547.79h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 332.92,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,332.92h227.2c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 261.3,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,261.3h227.2c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 332.92,
    width: 50.49,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,332.92h25.24c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-25.24c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 261.29,
    width: 58.06,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,261.29h32.56c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-32.56c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 618.83
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m787.51,114.58c2.01,0,3.78.35,5.28,1.06,1.51.69,2.69,1.67,3.53,2.94.83,1.26,1.25,2.74,1.25,4.44s-.33,3.15-.97,4.39c-.63,1.22-1.5,2.28-2.61,3.17s-2.55,1.85-4.33,2.89c-1.91,1.11-3.35,2.07-4.33,2.86-.97.78-1.63,1.51-2,2.19-.37.69-.58,1.46-.61,2.31h15.55v4.36h-21.58c-.04-.24-.06-.56-.06-.94,0-2.03.23-3.78.69-5.22.48-1.46,1.34-2.84,2.58-4.14,1.26-1.31,3.07-2.65,5.44-4,1.68-.98,2.98-1.81,3.89-2.5.92-.7,1.62-1.46,2.11-2.28.5-.81.75-1.76.75-2.86,0-1.28-.41-2.29-1.22-3.05-.82-.78-1.94-1.17-3.36-1.17-3.32,0-5.05,1.76-5.19,5.28h-5.3c.09-3.11,1.06-5.51,2.92-7.19,1.85-1.68,4.37-2.53,7.58-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.86,145.19v-21.05h-6.97v-3.83c2.42,0,4.22-.39,5.39-1.17,1.18-.79,1.9-2.09,2.17-3.89h4.67v29.94h-5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.7,145.19v-6.3h5.86v6.3h-5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.28,137.99v7.19h-5.25v-7.19h-14.27v-4.53l12.5-18.22h7.03v18.52h4.55v4.22h-4.55Zm-5.11-4.22v-3.86c0-3.11.07-6.62.22-10.55h-.11c-1.44,2.37-3.6,5.67-6.44,9.89l-3.14,4.53h9.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.46,146.52l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 118.05,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,118.05h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,118.05h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 118.05,
    width: 54.27,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,118.05h28.78c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-28.78c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,118.05h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m106.93,120.25c2.37,0,4.15.55,5.36,1.64,1.22,1.08,1.83,2.67,1.83,4.78h-3.3c0-1.22-.35-2.15-1.03-2.78-.67-.62-1.64-.94-2.92-.94-1.06,0-1.89.24-2.5.69-.61.47-.92,1.1-.92,1.89,0,.6.15,1.08.44,1.44.31.35.78.65,1.39.89.61.24,1.49.5,2.64.78,1.5.37,2.71.75,3.64,1.14.92.39,1.67.97,2.25,1.75.57.76.86,1.79.86,3.08,0,1.21-.31,2.26-.92,3.17-.6.89-1.44,1.58-2.55,2.08s-2.39.75-3.83.75c-2.39,0-4.25-.59-5.58-1.78-1.33-1.18-2-2.87-2-5.08h3.36c0,1.37.36,2.41,1.08,3.11.74.69,1.79,1.03,3.17,1.03,1.2,0,2.15-.26,2.83-.78.7-.53,1.06-1.26,1.06-2.19,0-.62-.16-1.12-.47-1.5-.32-.37-.76-.67-1.33-.89-.58-.22-1.46-.47-2.64-.75-1.52-.39-2.74-.78-3.67-1.17-.91-.39-1.66-.96-2.25-1.72-.58-.76-.86-1.78-.86-3.05,0-1.09.28-2.06.86-2.92.57-.85,1.37-1.51,2.39-1.97,1.03-.46,2.24-.69,3.61-.69Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.8,140.52c-1.61,0-2.86-.48-3.75-1.44-.89-.98-1.33-2.42-1.33-4.3v-8.53h3.14v8.25c0,2.33.94,3.5,2.83,3.5.92,0,1.68-.34,2.28-1.03.59-.7.89-1.69.89-2.97v-7.75h3.14v13.94h-2.97v-1.81h-.06c-.47.65-1.06,1.17-1.78,1.56-.71.39-1.5.58-2.39.58Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.23,125.89c1.17,0,2.18.31,3.05.92.89.6,1.56,1.44,2.03,2.55.48,1.11.72,2.4.72,3.86s-.24,2.75-.72,3.86c-.47,1.11-1.13,1.96-2,2.55-.87.59-1.89.89-3.05.89-.87,0-1.68-.19-2.42-.56-.72-.39-1.28-.92-1.67-1.58h-.06v6.89h-3.14v-19.02h3.05v1.92h.06c.4-.7.98-1.26,1.72-1.67.74-.4,1.54-.61,2.42-.61Zm-.92,2.44c-1.02,0-1.83.44-2.44,1.31-.61.87-.92,2.07-.92,3.58s.31,2.69.92,3.58c.61.87,1.42,1.31,2.44,1.31s1.92-.44,2.53-1.33c.62-.89.94-2.07.94-3.55s-.32-2.67-.94-3.55c-.61-.89-1.46-1.33-2.53-1.33Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.03,126.05c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.23,138.3c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.34,125.91c1.5,0,2.67.49,3.5,1.47.85.97,1.28,2.37,1.28,4.22v8.58h-3.11v-8.28c0-2.31-.85-3.47-2.53-3.47-.93,0-1.65.37-2.17,1.11-.52.74-.78,1.78-.78,3.11v7.53h-3.14v-8.61c0-1-.22-1.76-.64-2.31-.43-.56-1.05-.83-1.86-.83-.93,0-1.65.38-2.17,1.14-.5.74-.75,1.79-.75,3.14v7.47h-3.14v-13.94h3v1.67h.06c.48-.67,1.03-1.17,1.67-1.5.65-.33,1.37-.5,2.19-.5.96,0,1.81.22,2.53.67.72.43,1.25,1.05,1.58,1.86.53-.81,1.15-1.43,1.86-1.86.72-.44,1.59-.67,2.61-.67Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.79,138.3c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.57,120.25c1.56,0,2.92.31,4.08.92,1.18.6,2.1,1.43,2.75,2.5.65,1.08,1.01,2.31,1.08,3.69h-3.3c-.15-1.31-.63-2.34-1.44-3.08-.82-.74-1.87-1.11-3.17-1.11-1.67,0-2.99.65-3.94,1.94-.94,1.3-1.42,3.07-1.42,5.3s.47,4.04,1.42,5.33c.94,1.28,2.23,1.92,3.86,1.92,1.29,0,2.36-.37,3.19-1.11.83-.76,1.34-1.81,1.53-3.14h3.36c-.21,2.24-1.02,4-2.44,5.28-1.43,1.28-3.3,1.92-5.64,1.92-1.78,0-3.33-.41-4.64-1.22-1.3-.83-2.3-2.01-3-3.53-.69-1.53-1.03-3.35-1.03-5.44s.35-3.87,1.06-5.39c.7-1.53,1.71-2.71,3.03-3.53,1.31-.83,2.87-1.25,4.67-1.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.72,125.83c1.39,0,2.59.31,3.61.92,1.03.6,1.83,1.44,2.39,2.55.57,1.11.86,2.42.86,3.92s-.29,2.8-.86,3.92c-.56,1.11-1.35,1.97-2.39,2.58-1.02.59-2.22.89-3.61.89s-2.63-.3-3.67-.89c-1.04-.61-1.83-1.47-2.39-2.58s-.83-2.42-.83-3.92.28-2.8.83-3.92,1.35-1.96,2.39-2.55c1.03-.61,2.26-.92,3.67-.92Zm0,2.47c-1.13,0-2.02.44-2.67,1.33-.63.87-.94,2.07-.94,3.58s.31,2.72.94,3.61c.65.87,1.53,1.31,2.67,1.31s1.98-.43,2.61-1.31c.65-.89.97-2.09.97-3.61s-.33-2.71-.97-3.58c-.63-.89-1.5-1.33-2.61-1.33Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.55,140.52c-1.61,0-2.86-.48-3.75-1.44-.89-.98-1.33-2.42-1.33-4.3v-8.53h3.14v8.25c0,2.33.94,3.5,2.83,3.5.92,0,1.68-.34,2.28-1.03.59-.7.89-1.69.89-2.97v-7.75h3.14v13.94h-2.97v-1.81h-.06c-.47.65-1.06,1.17-1.78,1.56-.71.39-1.5.58-2.39.58Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.68,126.05c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.68,137.8c.39,0,.7-.04.94-.14v2.44c-.56.17-1.14.25-1.75.25-1.49,0-2.55-.33-3.22-1s-1-1.76-1-3.28v-7.44h-2.33v-2.39h2.33v-3.47h3.14v3.47h2.69v2.39h-2.69v6.97c0,.78.14,1.35.42,1.69.29.33.78.5,1.47.5Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.63,125.83c1.39,0,2.59.31,3.61.92,1.03.6,1.83,1.44,2.39,2.55.57,1.11.86,2.42.86,3.92s-.29,2.8-.86,3.92c-.56,1.11-1.35,1.97-2.39,2.58-1.02.59-2.22.89-3.61.89s-2.63-.3-3.67-.89c-1.04-.61-1.83-1.47-2.39-2.58s-.83-2.42-.83-3.92.28-2.8.83-3.92,1.35-1.96,2.39-2.55c1.03-.61,2.26-.92,3.67-.92Zm0,2.47c-1.13,0-2.02.44-2.67,1.33-.63.87-.94,2.07-.94,3.58s.31,2.72.94,3.61c.65.87,1.53,1.31,2.67,1.31s1.98-.43,2.61-1.31c.65-.89.97-2.09.97-3.61s-.33-2.71-.97-3.58c-.63-.89-1.5-1.33-2.61-1.33Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.32,122.86c-.69,0-1.19.18-1.53.53-.33.35-.5.94-.5,1.75v1.11h2.69v2.39h-2.69v11.55h-3.08v-11.55h-2.36v-2.39h2.36v-1.47c0-1.42.35-2.5,1.06-3.22.72-.72,1.78-1.08,3.17-1.08.46,0,1.01.07,1.64.19v2.31c-.26-.07-.51-.11-.75-.11Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.1,140.19v-19.52h3.3v19.52h-3.3Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.6,125.83c1.79,0,3.18.41,4.17,1.22.98.82,1.48,1.99,1.5,3.53h-3.03c0-.81-.24-1.42-.69-1.83-.47-.42-1.12-.64-1.97-.64-.72,0-1.29.15-1.69.44-.41.3-.61.71-.61,1.22,0,.37.1.68.31.92.22.22.53.41.92.56.4.13,1.06.31,1.94.53,1.2.3,2.14.58,2.8.86.67.26,1.24.69,1.72,1.28.48.6.72,1.41.72,2.44,0,1.28-.53,2.31-1.58,3.08s-2.47,1.17-4.25,1.17c-1.91,0-3.39-.42-4.44-1.28-1.04-.85-1.57-2.09-1.58-3.72h3.17c0,.85.25,1.51.75,1.97.51.47,1.24.69,2.17.69.78,0,1.39-.15,1.83-.47.46-.31.69-.73.69-1.25,0-.46-.12-.82-.36-1.08-.24-.28-.58-.49-1.03-.64-.44-.17-1.16-.36-2.14-.58-1.08-.28-1.92-.53-2.53-.78-.61-.24-1.14-.62-1.58-1.17-.44-.56-.67-1.32-.67-2.31,0-.81.23-1.53.69-2.17.46-.62,1.1-1.12,1.92-1.47.83-.35,1.78-.53,2.86-.53Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.71,126.05c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.33,125.83c1.87,0,3.28.47,4.25,1.39.98.91,1.47,2.27,1.47,4.08v5.22c0,1.5.12,2.72.36,3.67h-2.83c-.11-.57-.17-1.22-.17-1.94h-.06c-1.04,1.5-2.6,2.25-4.69,2.25-1.43,0-2.58-.39-3.44-1.17-.85-.78-1.28-1.76-1.28-2.97s.4-2.15,1.22-2.86c.81-.72,2.18-1.23,4.11-1.53,1.18-.2,2.44-.34,3.78-.42v-.56c0-.98-.25-1.7-.75-2.17-.49-.48-1.14-.72-1.97-.72s-1.52.22-2,.67c-.47.44-.72,1.04-.75,1.78h-3.08c.07-1.39.61-2.51,1.61-3.39,1-.89,2.4-1.33,4.22-1.33Zm2.72,7.75c-1.21.08-2.28.19-3.22.36-1,.17-1.71.42-2.14.75-.41.32-.61.8-.61,1.44,0,.61.21,1.11.64,1.5.44.37,1.06.56,1.83.56.5,0,.96-.07,1.39-.22.44-.17.82-.4,1.14-.72.37-.37.62-.76.75-1.19.15-.44.22-1.03.22-1.78v-.69Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m382.69,138.3c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.31,140.19v-19.52h3.14v19.52h-3.14Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.93,38.66c2.9,0,5.1.68,6.58,2.03,1.5,1.33,2.25,3.3,2.25,5.89h-4.08c0-1.51-.42-2.67-1.25-3.44s-2.03-1.17-3.58-1.17c-1.3,0-2.33.29-3.08.86-.76.58-1.14,1.36-1.14,2.36,0,.72.18,1.31.56,1.75.37.43.93.8,1.69,1.11.76.3,1.84.61,3.25.94,1.85.44,3.34.92,4.47,1.42,1.15.49,2.07,1.19,2.78,2.14.72.94,1.08,2.21,1.08,3.8,0,1.46-.38,2.76-1.14,3.89-.74,1.11-1.8,1.97-3.17,2.58-1.35.59-2.92.89-4.69.89-2.94,0-5.24-.72-6.89-2.17-1.65-1.46-2.47-3.55-2.47-6.28h4.17c0,1.69.44,2.96,1.33,3.83.9.85,2.2,1.28,3.89,1.28,1.5,0,2.67-.32,3.5-.97.85-.67,1.28-1.56,1.28-2.67,0-.79-.19-1.42-.58-1.86-.37-.46-.92-.82-1.64-1.08-.71-.28-1.78-.59-3.22-.94-1.89-.48-3.4-.95-4.53-1.42-1.13-.48-2.05-1.18-2.75-2.11-.71-.94-1.06-2.2-1.06-3.78,0-1.35.34-2.54,1.03-3.58.7-1.06,1.69-1.87,2.97-2.44,1.28-.57,2.76-.86,4.44-.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.45,63.63c-1.99,0-3.52-.59-4.61-1.78-1.1-1.2-1.64-2.97-1.64-5.3v-10.5h3.83v10.16c0,2.87,1.17,4.3,3.5,4.3,1.15,0,2.08-.42,2.8-1.28.74-.87,1.11-2.09,1.11-3.67v-9.53h3.83v17.16h-3.64v-2.22h-.08c-.56.82-1.28,1.46-2.17,1.94-.87.46-1.85.69-2.94.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.38,45.55c1.42,0,2.7.29,3.83.86,1.12.58,2.03,1.37,2.69,2.39.68,1,1.08,2.16,1.19,3.47h-4.03c-.1-1.12-.49-2.03-1.17-2.69-.67-.67-1.51-1-2.53-1-1.35,0-2.41.54-3.17,1.61-.76,1.08-1.14,2.55-1.14,4.44s.37,3.37,1.14,4.44c.76,1.08,1.81,1.61,3.17,1.61,1.01,0,1.86-.37,2.53-1.11.67-.74,1.04-1.7,1.14-2.89h4.05c-.19,2.1-.97,3.79-2.36,5.08-1.39,1.3-3.18,1.94-5.36,1.94-1.67,0-3.14-.37-4.42-1.11-1.26-.74-2.24-1.78-2.92-3.14-.69-1.37-1.03-2.98-1.03-4.83s.34-3.45,1.03-4.8c.68-1.37,1.65-2.42,2.92-3.17,1.28-.74,2.75-1.11,4.42-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.88,45.55c1.42,0,2.7.29,3.83.86,1.12.58,2.03,1.37,2.69,2.39.68,1,1.08,2.16,1.19,3.47h-4.03c-.1-1.12-.49-2.03-1.17-2.69-.67-.67-1.51-1-2.53-1-1.35,0-2.41.54-3.17,1.61-.76,1.08-1.14,2.55-1.14,4.44s.37,3.37,1.14,4.44c.76,1.08,1.81,1.61,3.17,1.61,1.01,0,1.86-.37,2.53-1.11.67-.74,1.04-1.7,1.14-2.89h4.05c-.19,2.1-.97,3.79-2.36,5.08-1.39,1.3-3.18,1.94-5.36,1.94-1.67,0-3.14-.37-4.42-1.11-1.26-.74-2.24-1.78-2.92-3.14-.69-1.37-1.03-2.98-1.03-4.83s.34-3.45,1.03-4.8c.68-1.37,1.65-2.42,2.92-3.17,1.28-.74,2.75-1.11,4.42-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.33,60.88c1.09,0,1.98-.26,2.67-.78.68-.51,1.12-1.2,1.31-2.06h3.94c-.33,1.63-1.21,2.99-2.61,4.05-1.39,1.08-3.16,1.61-5.3,1.61-1.71,0-3.19-.39-4.44-1.17-1.24-.78-2.19-1.86-2.86-3.25s-1-3.01-1-4.86c0-1.68.32-3.2.97-4.55.67-1.35,1.62-2.4,2.86-3.17,1.26-.78,2.73-1.17,4.42-1.17,1.92,0,3.57.53,4.94,1.58,1.37,1.04,2.28,2.46,2.75,4.25.31,1.02.47,2.36.47,4.03h-12.58c.06,1.85.49,3.24,1.31,4.14.83.89,1.89,1.33,3.17,1.33Zm-.06-12.5c-1.21,0-2.19.39-2.97,1.17s-1.22,1.87-1.39,3.33h8.69c-.15-1.46-.61-2.57-1.39-3.33-.78-.78-1.76-1.17-2.94-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.11,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.3,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.61,45.55c1.72,0,3.21.37,4.47,1.11,1.28.74,2.26,1.8,2.94,3.17.68,1.35,1.03,2.96,1.03,4.8s-.35,3.46-1.03,4.83c-.69,1.35-1.67,2.4-2.94,3.14-1.26.74-2.75,1.11-4.47,1.11s-3.21-.37-4.5-1.11c-1.28-.74-2.26-1.78-2.94-3.14-.69-1.37-1.03-2.98-1.03-4.83s.34-3.45,1.03-4.8c.68-1.37,1.67-2.42,2.94-3.17,1.29-.74,2.79-1.11,4.5-1.11Zm0,3.03c-1.37,0-2.46.55-3.25,1.64-.78,1.08-1.17,2.55-1.17,4.42s.39,3.35,1.17,4.44c.79,1.08,1.87,1.61,3.25,1.61s2.47-.53,3.25-1.61c.79-1.09,1.19-2.57,1.19-4.44s-.4-3.34-1.19-4.42c-.78-1.09-1.86-1.64-3.25-1.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.92,41.86c-.83,0-1.46.22-1.86.67-.39.44-.58,1.16-.58,2.14v1.39h3.3v2.94h-3.3v14.22h-3.83v-14.22h-2.89v-2.94h2.89v-1.81c0-1.76.43-3.08,1.31-3.97.89-.89,2.18-1.33,3.89-1.33.57,0,1.25.08,2.03.22v2.83c-.32-.09-.63-.14-.94-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.15,38.66c1.9,0,3.58.37,5.03,1.11,1.46.74,2.59,1.77,3.39,3.08.79,1.32,1.24,2.83,1.33,4.55h-4.08c-.19-1.59-.78-2.84-1.78-3.75-1-.92-2.3-1.39-3.89-1.39-2.06,0-3.68.8-4.86,2.39-1.17,1.6-1.75,3.77-1.75,6.53s.58,4.96,1.75,6.55c1.17,1.58,2.75,2.36,4.75,2.36,1.59,0,2.9-.46,3.92-1.39,1.03-.92,1.67-2.2,1.89-3.83h4.17c-.26,2.76-1.27,4.93-3.03,6.5-1.74,1.56-4.05,2.33-6.94,2.33-2.19,0-4.08-.5-5.69-1.5-1.61-1.01-2.85-2.46-3.69-4.33-.85-1.89-1.28-4.12-1.28-6.69s.42-4.79,1.28-6.67c.87-1.89,2.11-3.33,3.72-4.33,1.62-1.01,3.55-1.53,5.78-1.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.95,63.21v-24.05h3.83v24.05h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.14,45.55c2.29,0,4.04.57,5.25,1.69,1.2,1.13,1.81,2.8,1.81,5.03v6.42c0,1.85.15,3.36.44,4.53h-3.47c-.17-.7-.25-1.5-.25-2.39h-.06c-1.28,1.83-3.21,2.75-5.78,2.75-1.76,0-3.18-.47-4.25-1.42-1.06-.96-1.58-2.18-1.58-3.67s.5-2.62,1.5-3.5c1.01-.89,2.72-1.53,5.11-1.92,1.42-.24,2.96-.4,4.61-.5v-.67c0-1.22-.3-2.12-.89-2.69-.6-.57-1.41-.86-2.44-.86s-1.85.27-2.44.81c-.58.54-.89,1.27-.94,2.19h-3.78c.09-1.7.75-3.09,1.97-4.17,1.22-1.09,2.95-1.64,5.19-1.64Zm3.33,9.53c-1.46.1-2.78.24-3.94.44-1.24.21-2.12.51-2.64.92-.5.39-.75.99-.75,1.78s.26,1.37.78,1.83c.53.47,1.29.69,2.28.69.61,0,1.18-.09,1.72-.28.53-.18,1-.47,1.39-.86.44-.48.75-.98.92-1.5.17-.53.25-1.26.25-2.19v-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.93,63.21v-17.16h3.83v17.16h-3.83Zm0-20.36v-3.69h3.83v3.69h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.78,45.66c1.85,0,3.28.6,4.3,1.81,1.03,1.19,1.56,2.91,1.56,5.17v10.58h-3.83v-10.19c0-2.83-1.04-4.25-3.11-4.25-1.13,0-2.02.46-2.67,1.36-.63.91-.94,2.19-.94,3.83v9.25h-3.86v-10.61c0-1.2-.27-2.14-.81-2.8-.52-.68-1.27-1.03-2.25-1.03-1.17,0-2.07.47-2.69,1.39-.63.91-.94,2.19-.94,3.86v9.19h-3.83v-17.16h3.67v2.06h.08c.61-.83,1.29-1.44,2.06-1.83.78-.4,1.67-.61,2.69-.61,1.2,0,2.24.27,3.11.81.87.52,1.53,1.29,1.97,2.31.65-1.01,1.4-1.78,2.28-2.31.89-.53,1.96-.81,3.22-.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.33,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.5,56.69l-2.22,6.53h-4.25l8.75-24.05h5.44l8.75,24.05h-4.28l-2.22-6.53h-9.97Zm8.11-5.39c-1.35-4.01-2.39-7.2-3.11-9.55h-.06c-1.21,3.89-2.24,7.07-3.08,9.55l-.64,1.89h7.53l-.64-1.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.56,45.58c1.06,0,1.99.24,2.8.69.81.47,1.54,1.19,2.19,2.19h.08v-2.42h3.64v16.08c0,2.51-.69,4.42-2.06,5.69-1.35,1.28-3.27,1.92-5.75,1.92-2.28,0-4.05-.49-5.33-1.44-1.26-.97-1.94-2.3-2.03-4h3.86c.03.83.37,1.47,1,1.92.62.46,1.48.69,2.55.69,1.33,0,2.33-.39,3-1.17.67-.76,1-2.01,1-3.75v-1.69h-.06c-.65.93-1.38,1.61-2.19,2.06-.8.44-1.72.67-2.78.67-1.44,0-2.71-.35-3.78-1.06-1.08-.72-1.91-1.74-2.5-3.05-.58-1.31-.86-2.85-.86-4.61s.28-3.29.86-4.61c.59-1.31,1.43-2.32,2.53-3.03,1.09-.72,2.36-1.08,3.8-1.08Zm.89,3.22c-1.24,0-2.24.5-2.97,1.5-.72.99-1.08,2.32-1.08,4s.36,3.03,1.08,4.03c.74,1,1.73,1.5,2.97,1.5s2.32-.5,3.08-1.5c.76-1,1.14-2.34,1.14-4.03s-.38-3.01-1.14-4c-.76-1-1.79-1.5-3.08-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.63,45.55c2.29,0,4.04.57,5.25,1.69,1.2,1.13,1.81,2.8,1.81,5.03v6.42c0,1.85.15,3.36.44,4.53h-3.47c-.17-.7-.25-1.5-.25-2.39h-.06c-1.28,1.83-3.21,2.75-5.78,2.75-1.76,0-3.18-.47-4.25-1.42-1.06-.96-1.58-2.18-1.58-3.67s.5-2.62,1.5-3.5c1.01-.89,2.72-1.53,5.11-1.92,1.42-.24,2.96-.4,4.61-.5v-.67c0-1.22-.3-2.12-.89-2.69-.6-.57-1.41-.86-2.44-.86s-1.85.27-2.44.81c-.58.54-.89,1.27-.94,2.19h-3.78c.09-1.7.75-3.09,1.97-4.17,1.22-1.09,2.95-1.64,5.19-1.64Zm3.33,9.53c-1.46.1-2.78.24-3.94.44-1.24.21-2.12.51-2.64.92-.5.39-.75.99-.75,1.78s.26,1.37.78,1.83c.53.47,1.29.69,2.28.69.61,0,1.18-.09,1.72-.28.53-.18,1-.47,1.39-.86.44-.48.75-.98.92-1.5.17-.53.25-1.26.25-2.19v-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456.41,63.21v-17.16h3.83v17.16h-3.83Zm0-20.36v-3.69h3.83v3.69h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.02,45.66c1.98,0,3.51.6,4.61,1.81,1.09,1.19,1.64,2.94,1.64,5.25v10.5h-3.83v-10.16c0-2.85-1.17-4.28-3.5-4.28-1.15,0-2.1.43-2.83,1.28-.72.85-1.08,2.07-1.08,3.64v9.53h-3.83v-17.16h3.64v2.25h.08c.56-.81,1.26-1.45,2.14-1.92.89-.48,1.87-.72,2.97-.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490.96,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.11,60.27c.5,0,.89-.06,1.17-.17v3c-.69.2-1.4.31-2.14.31-1.83,0-3.17-.4-4-1.22-.82-.81-1.22-2.15-1.22-4.03v-9.16h-2.86v-2.94h2.86v-4.28h3.86v4.28h3.33v2.94h-3.33v8.58c0,.97.17,1.66.53,2.08.37.41.97.61,1.81.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.94,63.21v-24.05h4.05v24.05h-4.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m537.35,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.14,45.83c.46,0,.93.06,1.42.17v3.42c-.43-.09-.87-.14-1.33-.14-1.54,0-2.72.49-3.55,1.44-.82.94-1.22,2.31-1.22,4.08v8.41h-3.83v-17.16h3.58v2.53h.06c1.15-1.83,2.78-2.75,4.89-2.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.76,45.55c2.29,0,4.04.57,5.25,1.69,1.2,1.13,1.81,2.8,1.81,5.03v6.42c0,1.85.15,3.36.44,4.53h-3.47c-.17-.7-.25-1.5-.25-2.39h-.06c-1.28,1.83-3.21,2.75-5.78,2.75-1.76,0-3.18-.47-4.25-1.42-1.06-.96-1.58-2.18-1.58-3.67s.5-2.62,1.5-3.5c1.01-.89,2.72-1.53,5.11-1.92,1.42-.24,2.96-.4,4.61-.5v-.67c0-1.22-.3-2.12-.89-2.69-.6-.57-1.41-.86-2.44-.86s-1.85.27-2.44.81c-.58.54-.89,1.27-.94,2.19h-3.78c.09-1.7.75-3.09,1.97-4.17,1.22-1.09,2.95-1.64,5.19-1.64Zm3.33,9.53c-1.46.1-2.78.24-3.94.44-1.24.21-2.12.51-2.64.92-.5.39-.75.99-.75,1.78s.26,1.37.78,1.83c.53.47,1.29.69,2.28.69.61,0,1.18-.09,1.72-.28.53-.18,1-.47,1.39-.86.44-.48.75-.98.92-1.5.17-.53.25-1.26.25-2.19v-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m586.65,60.88c1.09,0,1.98-.26,2.67-.78.68-.51,1.12-1.2,1.31-2.06h3.94c-.33,1.63-1.21,2.99-2.61,4.05-1.39,1.08-3.16,1.61-5.3,1.61-1.71,0-3.19-.39-4.44-1.17-1.24-.78-2.19-1.86-2.86-3.25s-1-3.01-1-4.86c0-1.68.32-3.2.97-4.55.67-1.35,1.62-2.4,2.86-3.17,1.26-.78,2.73-1.17,4.42-1.17,1.92,0,3.57.53,4.94,1.58,1.37,1.04,2.28,2.46,2.75,4.25.31,1.02.47,2.36.47,4.03h-12.58c.06,1.85.49,3.24,1.31,4.14.83.89,1.89,1.33,3.17,1.33Zm-.06-12.5c-1.21,0-2.19.39-2.97,1.17s-1.22,1.87-1.39,3.33h8.69c-.15-1.46-.61-2.57-1.39-3.33-.78-.78-1.76-1.17-2.94-1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.52,63.21v-24.05h3.83v24.05h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618.98,48.3c.5-.83,1.19-1.49,2.08-1.97.89-.48,1.87-.72,2.94-.72,1.44,0,2.69.38,3.75,1.14,1.07.74,1.9,1.8,2.5,3.17.59,1.35.89,2.93.89,4.72s-.3,3.38-.89,4.75c-.6,1.37-1.43,2.43-2.5,3.17-1.08.72-2.33,1.08-3.78,1.08-1.1,0-2.1-.24-3-.72-.91-.5-1.61-1.18-2.11-2.06h-.06v2.36h-3.75v-24.05h3.83v9.14h.08Zm3.89.33c-1.26,0-2.27.54-3.03,1.61-.76,1.06-1.14,2.52-1.14,4.39s.37,3.33,1.14,4.42c.76,1.08,1.76,1.61,3.03,1.61s2.32-.54,3.08-1.64c.78-1.09,1.17-2.55,1.17-4.39s-.39-3.26-1.17-4.36c-.76-1.09-1.79-1.64-3.08-1.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.46,63.96c-.54,1.46-1.13,2.59-1.78,3.39-.65.81-1.43,1.4-2.33,1.75-.91.35-2.04.53-3.39.53-.69,0-1.33-.08-1.92-.22v-3.17c.51.17,1.06.25,1.61.25,1.03,0,1.83-.24,2.39-.69.56-.44,1.03-1.26,1.44-2.44l-6.28-17.3h4.11l4.28,12.77h.08l4.42-12.77h4l-6.64,17.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.79,38.66c1.9,0,3.58.37,5.03,1.11,1.46.74,2.59,1.77,3.39,3.08.79,1.32,1.24,2.83,1.33,4.55h-4.08c-.19-1.59-.78-2.84-1.78-3.75-1-.92-2.3-1.39-3.89-1.39-2.06,0-3.68.8-4.86,2.39-1.17,1.6-1.75,3.77-1.75,6.53s.58,4.96,1.75,6.55c1.17,1.58,2.75,2.36,4.75,2.36,1.59,0,2.9-.46,3.92-1.39,1.03-.92,1.67-2.2,1.89-3.83h4.17c-.26,2.76-1.27,4.93-3.03,6.5-1.74,1.56-4.05,2.33-6.94,2.33-2.19,0-4.08-.5-5.69-1.5-1.61-1.01-2.85-2.46-3.69-4.33-.85-1.89-1.28-4.12-1.28-6.69s.42-4.79,1.28-6.67c.87-1.89,2.11-3.33,3.72-4.33,1.62-1.01,3.55-1.53,5.78-1.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m689.87,45.55c1.72,0,3.21.37,4.47,1.11,1.28.74,2.26,1.8,2.94,3.17.68,1.35,1.03,2.96,1.03,4.8s-.35,3.46-1.03,4.83c-.69,1.35-1.67,2.4-2.94,3.14-1.26.74-2.75,1.11-4.47,1.11s-3.21-.37-4.5-1.11c-1.28-.74-2.26-1.78-2.94-3.14-.69-1.37-1.03-2.98-1.03-4.83s.34-3.45,1.03-4.8c.68-1.37,1.67-2.42,2.94-3.17,1.29-.74,2.79-1.11,4.5-1.11Zm0,3.03c-1.37,0-2.46.55-3.25,1.64-.78,1.08-1.17,2.55-1.17,4.42s.39,3.35,1.17,4.44c.79,1.08,1.87,1.61,3.25,1.61s2.47-.53,3.25-1.61c.79-1.09,1.19-2.57,1.19-4.44s-.4-3.34-1.19-4.42c-.78-1.09-1.86-1.64-3.25-1.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m708.15,63.63c-1.99,0-3.52-.59-4.61-1.78-1.1-1.2-1.64-2.97-1.64-5.3v-10.5h3.83v10.16c0,2.87,1.17,4.3,3.5,4.3,1.15,0,2.08-.42,2.8-1.28.74-.87,1.11-2.09,1.11-3.67v-9.53h3.83v17.16h-3.64v-2.22h-.08c-.56.82-1.28,1.46-2.17,1.94-.87.46-1.85.69-2.94.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.45,45.83c.46,0,.93.06,1.42.17v3.42c-.43-.09-.87-.14-1.33-.14-1.54,0-2.72.49-3.55,1.44-.82.94-1.22,2.31-1.22,4.08v8.41h-3.83v-17.16h3.58v2.53h.06c1.15-1.83,2.78-2.75,4.89-2.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m741.54,60.27c.5,0,.89-.06,1.17-.17v3c-.69.2-1.4.31-2.14.31-1.83,0-3.17-.4-4-1.22-.82-.81-1.22-2.15-1.22-4.03v-9.16h-2.86v-2.94h2.86v-4.28h3.86v4.28h3.33v2.94h-3.33v8.58c0,.97.17,1.66.53,2.08.37.41.97.61,1.81.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m762.06,39.16c4.03,0,7.14,1.05,9.33,3.14,2.18,2.08,3.28,5.04,3.28,8.89s-1.1,6.82-3.28,8.91c-2.19,2.08-5.3,3.11-9.33,3.11h-7.69v-24.05h7.69Zm-3.67,20.55h3.61c2.79,0,4.9-.71,6.33-2.14,1.42-1.44,2.14-3.57,2.14-6.39s-.72-4.93-2.14-6.36c-1.43-1.42-3.54-2.14-6.33-2.14h-3.61v17.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m778.48,63.21v-17.16h3.83v17.16h-3.83Zm0-20.36v-3.69h3.83v3.69h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.17,45.55c2.2,0,3.9.5,5.11,1.5,1.2,1,1.81,2.44,1.83,4.33h-3.72c0-1-.28-1.75-.83-2.25-.56-.51-1.37-.78-2.44-.78-.89,0-1.58.19-2.08.56-.5.35-.75.85-.75,1.47,0,.47.12.85.39,1.14.26.28.64.5,1.14.67s1.28.39,2.36.67c1.48.37,2.62.72,3.44,1.06.83.33,1.54.87,2.14,1.61.61.72.92,1.71.92,2.97,0,1.58-.66,2.85-1.97,3.8-1.32.94-3.05,1.42-5.22,1.42-2.35,0-4.18-.51-5.47-1.56-1.3-1.06-1.96-2.58-1.97-4.58h3.92c0,1.06.31,1.87.92,2.44.62.56,1.51.83,2.67.83.96,0,1.72-.18,2.28-.56.56-.39.83-.92.83-1.58,0-.56-.15-.99-.44-1.31-.3-.33-.72-.59-1.28-.78-.54-.2-1.41-.45-2.61-.75-1.33-.33-2.38-.65-3.14-.94-.74-.29-1.38-.78-1.92-1.44-.54-.68-.81-1.62-.81-2.8,0-1.01.28-1.92.83-2.69s1.34-1.37,2.36-1.81c1.01-.42,2.19-.64,3.53-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m811.33,60.27c.5,0,.89-.06,1.17-.17v3c-.69.2-1.4.31-2.14.31-1.83,0-3.17-.4-4-1.22-.82-.81-1.22-2.15-1.22-4.03v-9.16h-2.86v-2.94h2.86v-4.28h3.86v4.28h3.33v2.94h-3.33v8.58c0,.97.17,1.66.53,2.08.37.41.97.61,1.81.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m824.41,45.83c.46,0,.93.06,1.42.17v3.42c-.43-.09-.87-.14-1.33-.14-1.54,0-2.72.49-3.55,1.44-.82.94-1.22,2.31-1.22,4.08v8.41h-3.83v-17.16h3.58v2.53h.06c1.15-1.83,2.78-2.75,4.89-2.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.61,63.21v-17.16h3.83v17.16h-3.83Zm0-20.36v-3.69h3.83v3.69h-3.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844.56,45.55c1.42,0,2.7.29,3.83.86,1.12.58,2.03,1.37,2.69,2.39.68,1,1.08,2.16,1.19,3.47h-4.03c-.1-1.12-.49-2.03-1.17-2.69-.67-.67-1.51-1-2.53-1-1.35,0-2.41.54-3.17,1.61-.76,1.08-1.14,2.55-1.14,4.44s.37,3.37,1.14,4.44c.76,1.08,1.81,1.61,3.17,1.61,1.01,0,1.86-.37,2.53-1.11.67-.74,1.04-1.7,1.14-2.89h4.05c-.19,2.1-.97,3.79-2.36,5.08-1.39,1.3-3.18,1.94-5.36,1.94-1.67,0-3.14-.37-4.42-1.11-1.26-.74-2.24-1.78-2.92-3.14-.69-1.37-1.03-2.98-1.03-4.83s.34-3.45,1.03-4.8c.68-1.37,1.65-2.42,2.92-3.17,1.28-.74,2.75-1.11,4.42-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.78,60.27c.5,0,.89-.06,1.17-.17v3c-.69.2-1.4.31-2.14.31-1.83,0-3.17-.4-4-1.22-.82-.81-1.22-2.15-1.22-4.03v-9.16h-2.86v-2.94h2.86v-4.28h3.86v4.28h3.33v2.94h-3.33v8.58c0,.97.17,1.66.53,2.08.37.41.97.61,1.81.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.46,186.21c3.15,0,5.64.76,7.47,2.28,1.83,1.5,2.75,3.51,2.75,6.03,0,1.72-.43,3.13-1.28,4.22-.83,1.1-2.14,1.96-3.92,2.61v.08c1.96.67,3.4,1.6,4.3,2.78.92,1.19,1.39,2.74,1.39,4.67,0,1.71-.44,3.21-1.33,4.53-.89,1.3-2.14,2.31-3.75,3.03-1.61.7-3.47,1.06-5.58,1.06-3.5,0-6.21-.87-8.11-2.61-1.91-1.76-2.86-4.25-2.86-7.47h5.33c0,1.87.47,3.29,1.42,4.25.94.97,2.35,1.44,4.22,1.44,1.59,0,2.87-.4,3.86-1.22.98-.81,1.47-1.89,1.47-3.22,0-3.15-2.19-4.72-6.58-4.72h-1.06v-4.3h1.06c1.9,0,3.42-.42,4.53-1.25,1.11-.85,1.67-1.98,1.67-3.39,0-1.29-.49-2.35-1.44-3.17-.94-.81-2.19-1.22-3.72-1.22-1.67,0-2.94.46-3.83,1.36-.89.91-1.33,2.26-1.33,4.05h-5.28c0-3.07.93-5.47,2.8-7.19,1.89-1.74,4.49-2.61,7.8-2.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.38,186.21c1.98,0,3.75.35,5.3,1.03,1.57.67,2.79,1.63,3.67,2.89.89,1.24,1.33,2.68,1.33,4.3s-.49,3.04-1.44,4.22c-.94,1.19-2.24,2.04-3.89,2.55v.11c1.87.52,3.32,1.43,4.36,2.72,1.06,1.3,1.58,2.86,1.58,4.69s-.46,3.33-1.36,4.64c-.89,1.32-2.17,2.33-3.83,3.05-1.67.7-3.58,1.06-5.72,1.06s-4.13-.35-5.78-1.06c-1.63-.72-2.91-1.74-3.83-3.05-.93-1.31-1.39-2.86-1.39-4.64s.53-3.4,1.58-4.69c1.06-1.29,2.51-2.2,4.39-2.72v-.11c-1.67-.51-2.97-1.37-3.92-2.55-.94-1.18-1.42-2.59-1.42-4.22s.44-3.06,1.33-4.3c.89-1.26,2.11-2.22,3.67-2.89,1.56-.68,3.34-1.03,5.36-1.03Zm0,4.33c-1.58,0-2.85.39-3.8,1.17-.97.78-1.44,1.8-1.44,3.05,0,1.41.46,2.51,1.39,3.3.94.8,2.23,1.19,3.86,1.19s2.85-.4,3.78-1.19c.94-.79,1.42-1.9,1.42-3.3,0-1.26-.49-2.28-1.44-3.05-.94-.78-2.19-1.17-3.75-1.17Zm0,13c-1.71,0-3.08.44-4.11,1.31-1.04.87-1.56,2.02-1.56,3.44s.5,2.6,1.5,3.47c1.01.85,2.4,1.28,4.17,1.28s3.06-.42,4.08-1.28c1.03-.87,1.56-2.03,1.56-3.47s-.52-2.53-1.56-3.42c-1.04-.89-2.4-1.33-4.08-1.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.7,216.81v-6.3h5.86v6.3h-5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.95,186.21c1.98,0,3.75.35,5.3,1.03,1.57.67,2.79,1.63,3.67,2.89.89,1.24,1.33,2.68,1.33,4.3s-.49,3.04-1.44,4.22c-.94,1.19-2.24,2.04-3.89,2.55v.11c1.87.52,3.32,1.43,4.36,2.72,1.06,1.3,1.58,2.86,1.58,4.69s-.46,3.33-1.36,4.64c-.89,1.32-2.17,2.33-3.83,3.05-1.67.7-3.58,1.06-5.72,1.06s-4.13-.35-5.78-1.06c-1.63-.72-2.91-1.74-3.83-3.05-.93-1.31-1.39-2.86-1.39-4.64s.53-3.4,1.58-4.69c1.06-1.29,2.51-2.2,4.39-2.72v-.11c-1.67-.51-2.97-1.37-3.92-2.55-.94-1.18-1.42-2.59-1.42-4.22s.44-3.06,1.33-4.3c.89-1.26,2.11-2.22,3.67-2.89,1.56-.68,3.34-1.03,5.36-1.03Zm0,4.33c-1.58,0-2.85.39-3.8,1.17-.97.78-1.44,1.8-1.44,3.05,0,1.41.46,2.51,1.39,3.3.94.8,2.23,1.19,3.86,1.19s2.85-.4,3.78-1.19c.94-.79,1.42-1.9,1.42-3.3,0-1.26-.49-2.28-1.44-3.05-.94-.78-2.19-1.17-3.75-1.17Zm0,13c-1.71,0-3.08.44-4.11,1.31-1.04.87-1.56,2.02-1.56,3.44s.5,2.6,1.5,3.47c1.01.85,2.4,1.28,4.17,1.28s3.06-.42,4.08-1.28c1.03-.87,1.56-2.03,1.56-3.47s-.52-2.53-1.56-3.42c-1.04-.89-2.4-1.33-4.08-1.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.46,218.14l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 189.67,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,189.67h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,189.67h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 189.67,
    width: 98.03,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,189.67h72.7c6.98,0,12.62,5.65,12.62,12.62s-5.64,12.62-12.62,12.62h-72.7c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,189.67h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m203.53,195.12v16.69h-3.28v-16.69h-6.42v-2.83h16.11v2.83h-6.42Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.01,209.92c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.62,211.81v-19.52h3.14v19.52h-3.14Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.45,206.51l-1.83,5.3h-3.44l7.11-19.52h4.42l7.11,19.52h-3.47l-1.81-5.3h-8.08Zm6.58-4.39c-1.11-3.26-1.96-5.84-2.53-7.75h-.06c-.97,3.17-1.8,5.75-2.5,7.75l-.53,1.56h6.14l-.53-1.56Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.6,211.81l-4.86-13.94h3.28l1.81,5.69c.59,1.83,1.18,3.86,1.78,6.08h.06c.59-2.22,1.18-4.25,1.78-6.08l1.81-5.69h3.28l-4.86,13.94h-4.05Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.35,211.81v-13.94h3.14v13.94h-3.14Zm0-16.55v-2.97h3.14v2.97h-3.14Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.18,211.81l-4.86-13.94h3.28l1.81,5.69c.59,1.83,1.18,3.86,1.78,6.08h.06c.59-2.22,1.18-4.25,1.78-6.08l1.81-5.69h3.28l-4.86,13.94h-4.05Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m786.04,431.68v-21.05h-6.97v-3.83c2.42,0,4.22-.39,5.39-1.17,1.18-.79,1.9-2.09,2.17-3.89h4.67v29.94h-5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.91,406.3c-2.32,3.33-4.36,7.18-6.14,11.53-1.78,4.35-3.11,8.97-4,13.86h-5.78c1.15-5.37,2.68-10.23,4.61-14.61,1.92-4.39,3.96-8.01,6.11-10.86h-16.36v-4.47h21.55v4.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.7,431.68v-6.3h5.86v6.3h-5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m849.9,401.07c2.01,0,3.78.35,5.28,1.06,1.51.69,2.69,1.67,3.53,2.94.83,1.26,1.25,2.74,1.25,4.44s-.33,3.15-.97,4.39c-.63,1.22-1.5,2.28-2.61,3.17s-2.55,1.85-4.33,2.89c-1.91,1.11-3.35,2.07-4.33,2.86-.97.78-1.63,1.51-2,2.19-.37.69-.58,1.46-.61,2.31h15.55v4.36h-21.58c-.04-.24-.06-.56-.06-.94,0-2.03.23-3.78.69-5.22.48-1.46,1.34-2.84,2.58-4.14,1.26-1.31,3.07-2.65,5.44-4,1.68-.98,2.98-1.81,3.89-2.5.92-.7,1.62-1.46,2.11-2.28.5-.81.75-1.76.75-2.86,0-1.28-.41-2.29-1.22-3.05-.82-.78-1.94-1.17-3.36-1.17-3.32,0-5.05,1.76-5.19,5.28h-5.3c.09-3.11,1.06-5.51,2.92-7.19,1.85-1.68,4.37-2.53,7.58-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.46,433.01l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 404.54,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-8)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,404.54h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-9)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,404.54h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 404.54,
    width: 43.75,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-10)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,404.54h18.18c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-18.18c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-11)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,404.54h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m203.86,420.77c0,2.06-.49,3.58-1.47,4.58-.99,1-2.5,1.5-4.55,1.5-.56,0-1.08-.07-1.56-.19v-2.83c.39.08.79.11,1.22.11,1.07,0,1.85-.26,2.33-.81.48-.56.72-1.53.72-2.94v-13.02h3.3v13.61Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.92,424.79c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.48,412.54c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.82,427.01c-1.61,0-2.86-.48-3.75-1.44-.89-.98-1.33-2.42-1.33-4.3v-8.53h3.14v8.25c0,2.33.94,3.5,2.83,3.5.92,0,1.68-.34,2.28-1.03.59-.7.89-1.69.89-2.97v-7.75h3.14v13.94h-2.97v-1.81h-.06c-.47.65-1.06,1.17-1.78,1.56-.71.39-1.5.58-2.39.58Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.81,412.32c1.79,0,3.18.41,4.17,1.22.98.82,1.48,1.99,1.5,3.53h-3.03c0-.81-.24-1.42-.69-1.83-.47-.42-1.12-.64-1.97-.64-.72,0-1.29.15-1.69.44-.41.3-.61.71-.61,1.22,0,.37.1.68.31.92.22.22.53.41.92.56.4.13,1.06.31,1.94.53,1.2.3,2.14.58,2.8.86.67.26,1.24.69,1.72,1.28.48.6.72,1.41.72,2.44,0,1.28-.53,2.31-1.58,3.08s-2.47,1.17-4.25,1.17c-1.91,0-3.39-.42-4.44-1.28-1.04-.85-1.57-2.09-1.58-3.72h3.17c0,.85.25,1.51.75,1.97.51.47,1.24.69,2.17.69.78,0,1.39-.15,1.83-.47.46-.31.69-.73.69-1.25,0-.46-.12-.82-.36-1.08-.24-.28-.58-.49-1.03-.64-.44-.17-1.16-.36-2.14-.58-1.08-.28-1.92-.53-2.53-.78-.61-.24-1.14-.62-1.58-1.17-.44-.56-.67-1.32-.67-2.31,0-.81.23-1.53.69-2.17.46-.62,1.1-1.12,1.92-1.47.83-.35,1.78-.53,2.86-.53Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.19,412.32c1.87,0,3.28.47,4.25,1.39.98.91,1.47,2.27,1.47,4.08v5.22c0,1.5.12,2.72.36,3.67h-2.83c-.11-.57-.17-1.22-.17-1.94h-.06c-1.04,1.5-2.6,2.25-4.69,2.25-1.43,0-2.58-.39-3.44-1.17-.85-.78-1.28-1.76-1.28-2.97s.4-2.15,1.22-2.86c.81-.72,2.18-1.23,4.11-1.53,1.18-.2,2.44-.34,3.78-.42v-.56c0-.98-.25-1.7-.75-2.17-.49-.48-1.14-.72-1.97-.72s-1.52.22-2,.67c-.47.44-.72,1.04-.75,1.78h-3.08c.07-1.39.61-2.51,1.61-3.39,1-.89,2.4-1.33,4.22-1.33Zm2.72,7.75c-1.21.08-2.28.19-3.22.36-1,.17-1.71.42-2.14.75-.41.32-.61.8-.61,1.44,0,.61.21,1.11.64,1.5.44.37,1.06.56,1.83.56.5,0,.96-.07,1.39-.22.44-.17.82-.4,1.14-.72.37-.37.62-.76.75-1.19.15-.44.22-1.03.22-1.78v-.69Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.76,426.68v-19.52h3.14v19.52h-3.14Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.69,424.79c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.8,412.41c1.5,0,2.67.49,3.5,1.47.85.97,1.28,2.37,1.28,4.22v8.58h-3.11v-8.28c0-2.31-.85-3.47-2.53-3.47-.93,0-1.65.37-2.17,1.11-.52.74-.78,1.78-.78,3.11v7.53h-3.14v-8.61c0-1-.22-1.76-.64-2.31-.43-.56-1.05-.83-1.86-.83-.93,0-1.65.38-2.17,1.14-.5.74-.75,1.79-.75,3.14v7.47h-3.14v-13.94h3v1.67h.06c.48-.67,1.03-1.17,1.67-1.5.65-.33,1.37-.5,2.19-.5.96,0,1.81.22,2.53.67.72.43,1.25,1.05,1.58,1.86.53-.81,1.15-1.43,1.86-1.86.72-.44,1.59-.67,2.61-.67Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.48,472.7c2.81,0,5.06.76,6.75,2.28,1.7,1.52,2.65,3.63,2.86,6.33h-5.33c-.21-1.39-.69-2.43-1.44-3.14-.76-.72-1.78-1.08-3.05-1.08-1.94,0-3.51.85-4.69,2.53-1.17,1.67-1.8,4.21-1.89,7.61h.11c1.79-2.31,4.17-3.47,7.11-3.47,1.89,0,3.56.42,5.03,1.25,1.46.83,2.59,1.99,3.39,3.47.81,1.49,1.22,3.19,1.22,5.11,0,2.04-.46,3.85-1.36,5.42-.91,1.58-2.18,2.8-3.8,3.67-1.63.87-3.49,1.31-5.58,1.31-3.6,0-6.35-1.23-8.25-3.69-1.89-2.46-2.83-6.1-2.83-10.91,0-5.37,1.03-9.48,3.08-12.36,2.07-2.87,4.97-4.3,8.69-4.3Zm-.61,15.19c-1.61,0-2.9.55-3.86,1.64-.97,1.08-1.44,2.5-1.44,4.28s.46,3.19,1.39,4.22c.94,1.04,2.22,1.56,3.83,1.56s2.87-.53,3.83-1.58c.96-1.06,1.44-2.49,1.44-4.3s-.47-3.14-1.42-4.19c-.94-1.07-2.21-1.61-3.78-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m802.89,503.3v-6.3h5.86v6.3h-5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m824.02,472.7c3.15,0,5.64.76,7.47,2.28,1.83,1.5,2.75,3.51,2.75,6.03,0,1.72-.43,3.13-1.28,4.22-.83,1.1-2.14,1.96-3.92,2.61v.08c1.96.67,3.4,1.6,4.3,2.78.92,1.19,1.39,2.74,1.39,4.67,0,1.71-.44,3.21-1.33,4.53-.89,1.3-2.14,2.31-3.75,3.03-1.61.7-3.47,1.06-5.58,1.06-3.5,0-6.21-.87-8.11-2.61-1.91-1.76-2.86-4.25-2.86-7.47h5.33c0,1.87.47,3.29,1.42,4.25.94.97,2.35,1.44,4.22,1.44,1.59,0,2.87-.4,3.86-1.22.98-.81,1.47-1.89,1.47-3.22,0-3.15-2.19-4.72-6.58-4.72h-1.06v-4.3h1.06c1.9,0,3.42-.42,4.53-1.25,1.11-.85,1.67-1.98,1.67-3.39,0-1.29-.49-2.35-1.44-3.17-.94-.81-2.19-1.22-3.72-1.22-1.67,0-2.94.46-3.83,1.36-.89.91-1.33,2.26-1.33,4.05h-5.28c0-3.07.93-5.47,2.8-7.19,1.89-1.74,4.49-2.61,7.8-2.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m846.65,504.63l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 476.17,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-12)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,476.17h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-13)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,476.17h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 476.17,
    width: 25.24,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-14)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,476.17c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62-12.62-5.65-12.62-12.62,5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-15)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,476.17h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m232.21,478.36c2.37,0,4.15.55,5.36,1.64,1.22,1.08,1.83,2.67,1.83,4.78h-3.3c0-1.22-.35-2.15-1.03-2.78-.67-.62-1.64-.94-2.92-.94-1.06,0-1.89.24-2.5.69-.61.47-.92,1.1-.92,1.89,0,.6.15,1.08.44,1.44.31.35.78.65,1.39.89.61.24,1.49.5,2.64.78,1.5.37,2.71.75,3.64,1.14.92.39,1.67.97,2.25,1.75.57.76.86,1.79.86,3.08,0,1.21-.31,2.26-.92,3.17-.6.89-1.44,1.58-2.55,2.08s-2.39.75-3.83.75c-2.39,0-4.25-.59-5.58-1.78-1.33-1.18-2-2.87-2-5.08h3.36c0,1.37.36,2.41,1.08,3.11.74.69,1.79,1.03,3.17,1.03,1.2,0,2.15-.26,2.83-.78.7-.53,1.06-1.26,1.06-2.19,0-.62-.16-1.12-.47-1.5-.32-.37-.76-.67-1.33-.89-.58-.22-1.46-.47-2.64-.75-1.52-.39-2.74-.78-3.67-1.17-.91-.39-1.66-.96-2.25-1.72-.58-.76-.86-1.78-.86-3.05,0-1.09.28-2.06.86-2.92.57-.85,1.37-1.51,2.39-1.97,1.03-.46,2.24-.69,3.61-.69Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.08,483.95c1.39,0,2.59.31,3.61.92,1.03.6,1.83,1.44,2.39,2.55.57,1.11.86,2.42.86,3.92s-.29,2.8-.86,3.92c-.56,1.11-1.35,1.97-2.39,2.58-1.02.59-2.22.89-3.61.89s-2.63-.3-3.67-.89c-1.04-.61-1.83-1.47-2.39-2.58s-.83-2.42-.83-3.92.28-2.8.83-3.92,1.35-1.96,2.39-2.55c1.03-.61,2.26-.92,3.67-.92Zm0,2.47c-1.13,0-2.02.44-2.67,1.33-.63.87-.94,2.07-.94,3.58s.31,2.72.94,3.61c.65.87,1.53,1.31,2.67,1.31s1.98-.43,2.61-1.31c.65-.89.97-2.09.97-3.61s-.33-2.71-.97-3.58c-.63-.89-1.5-1.33-2.61-1.33Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.91,498.64c-1.61,0-2.86-.48-3.75-1.44-.89-.98-1.33-2.42-1.33-4.3v-8.53h3.14v8.25c0,2.33.94,3.5,2.83,3.5.92,0,1.68-.34,2.28-1.03.59-.7.89-1.69.89-2.97v-7.75h3.14v13.94h-2.97v-1.81h-.06c-.47.65-1.06,1.17-1.78,1.56-.71.39-1.5.58-2.39.58Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.7,495.92c.39,0,.7-.04.94-.14v2.44c-.56.17-1.14.25-1.75.25-1.49,0-2.55-.33-3.22-1s-1-1.76-1-3.28v-7.44h-2.33v-2.39h2.33v-3.47h3.14v3.47h2.69v2.39h-2.69v6.97c0,.78.14,1.35.42,1.69.29.33.78.5,1.47.5Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.59,486c.46-.65,1.04-1.14,1.75-1.47.7-.33,1.45-.5,2.25-.5,1.61,0,2.86.49,3.75,1.47.89.97,1.33,2.39,1.33,4.28v8.53h-3.14v-8.25c0-2.33-.94-3.5-2.83-3.5-.93,0-1.69.35-2.28,1.06-.6.69-.89,1.67-.89,2.94v7.75h-3.14v-19.52h3.14v7.22h.06Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.57,544.32c3.67,0,6.47,1.35,8.41,4.05,1.96,2.69,2.94,6.55,2.94,11.58s-.99,8.91-2.94,11.61c-1.94,2.69-4.75,4.03-8.41,4.03s-6.52-1.34-8.5-4.03c-1.96-2.7-2.94-6.57-2.94-11.61s.98-8.89,2.94-11.58c1.98-2.7,4.81-4.05,8.5-4.05Zm0,4.47c-1.93,0-3.41.97-4.44,2.89-1.02,1.91-1.53,4.67-1.53,8.28s.51,6.39,1.53,8.33c1.03,1.94,2.51,2.92,4.44,2.92s3.34-.97,4.36-2.92c1.01-1.94,1.53-4.72,1.53-8.33s-.51-6.37-1.53-8.28c-1.02-1.92-2.47-2.89-4.36-2.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m810.08,576.26l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 547.79,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-16)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,547.79h227.2c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-17)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,547.79h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m227.29,549.99c1.56,0,2.92.31,4.08.92,1.18.6,2.1,1.43,2.75,2.5.65,1.08,1.01,2.31,1.08,3.69h-3.3c-.15-1.31-.63-2.34-1.44-3.08-.82-.74-1.87-1.11-3.17-1.11-1.67,0-2.99.65-3.94,1.94-.94,1.3-1.42,3.07-1.42,5.3s.47,4.04,1.42,5.33c.94,1.28,2.23,1.92,3.86,1.92,1.29,0,2.36-.37,3.19-1.11.83-.76,1.34-1.81,1.53-3.14h3.36c-.21,2.24-1.02,4-2.44,5.28-1.43,1.28-3.3,1.92-5.64,1.92-1.78,0-3.33-.41-4.64-1.22-1.3-.83-2.3-2.01-3-3.53-.69-1.53-1.03-3.35-1.03-5.44s.35-3.87,1.06-5.39c.7-1.53,1.71-2.71,3.03-3.53,1.31-.83,2.87-1.25,4.67-1.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.3,568.04c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.1,555.65c1.61,0,2.86.49,3.75,1.47.89.97,1.33,2.39,1.33,4.28v8.53h-3.14v-8.25c0-2.33-.94-3.5-2.83-3.5-.93,0-1.69.35-2.28,1.06-.6.69-.89,1.67-.89,2.94v7.75h-3.14v-13.94h2.97v1.81h.06c.46-.65,1.04-1.17,1.75-1.56.72-.39,1.53-.58,2.42-.58Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.65,567.54c.39,0,.7-.04.94-.14v2.44c-.56.17-1.14.25-1.75.25-1.49,0-2.55-.33-3.22-1s-1-1.76-1-3.28v-7.44h-2.33v-2.39h2.33v-3.47h3.14v3.47h2.69v2.39h-2.69v6.97c0,.78.14,1.35.42,1.69.29.33.78.5,1.47.5Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.14,568.04c.87,0,1.58-.21,2.14-.64.56-.42.9-.98,1.06-1.67h3.22c-.28,1.32-.99,2.42-2.14,3.3-1.13.87-2.55,1.31-4.28,1.31-1.39,0-2.6-.32-3.61-.94-1.02-.62-1.8-1.51-2.33-2.64-.54-1.15-.81-2.47-.81-3.97,0-1.37.26-2.6.78-3.69.53-1.11,1.31-1.97,2.33-2.58,1.01-.62,2.21-.94,3.58-.94,1.57,0,2.9.43,4,1.28,1.11.85,1.86,2.01,2.25,3.47.26.83.39,1.93.39,3.28h-10.25c.06,1.5.42,2.62,1.08,3.36.67.72,1.53,1.08,2.58,1.08Zm-.06-10.16c-.99,0-1.79.32-2.42.94-.63.61-1.01,1.52-1.14,2.72h7.05c-.11-1.2-.49-2.11-1.11-2.72-.63-.62-1.43-.94-2.39-.94Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.7,555.79c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.51,329.45c2.01,0,3.78.35,5.28,1.06,1.51.69,2.69,1.67,3.53,2.94.83,1.26,1.25,2.74,1.25,4.44s-.33,3.15-.97,4.39c-.63,1.22-1.5,2.28-2.61,3.17s-2.55,1.85-4.33,2.89c-1.91,1.11-3.35,2.07-4.33,2.86-.97.78-1.63,1.51-2,2.19-.37.69-.58,1.46-.61,2.31h15.55v4.36h-21.58c-.04-.24-.06-.56-.06-.94,0-2.03.23-3.78.69-5.22.48-1.46,1.34-2.84,2.58-4.14,1.26-1.31,3.07-2.65,5.44-4,1.68-.98,2.98-1.81,3.89-2.5.92-.7,1.62-1.46,2.11-2.28.5-.81.75-1.76.75-2.86,0-1.28-.41-2.29-1.22-3.05-.82-.78-1.94-1.17-3.36-1.17-3.32,0-5.05,1.76-5.19,5.28h-5.3c.09-3.11,1.06-5.51,2.92-7.19,1.85-1.68,4.37-2.53,7.58-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.38,329.45c3.67,0,6.47,1.35,8.41,4.05,1.96,2.69,2.94,6.55,2.94,11.58s-.99,8.91-2.94,11.61c-1.94,2.69-4.75,4.03-8.41,4.03s-6.52-1.34-8.5-4.03c-1.96-2.7-2.94-6.57-2.94-11.61s.98-8.89,2.94-11.58c1.98-2.7,4.81-4.05,8.5-4.05Zm0,4.47c-1.93,0-3.41.97-4.44,2.89-1.02,1.91-1.53,4.67-1.53,8.28s.51,6.39,1.53,8.33c1.03,1.94,2.51,2.92,4.44,2.92s3.34-.97,4.36-2.92c1.01-1.94,1.53-4.72,1.53-8.33s-.51-6.37-1.53-8.28c-1.02-1.92-2.47-2.89-4.36-2.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m835.89,361.39l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 332.92,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-18)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,332.92h227.2c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-19)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,332.92h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 261.3,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-20)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,261.3h227.2c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-227.2c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-21)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,261.3h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#666"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 332.92,
    width: 50.49,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-22)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,332.92h25.24c6.97,0,12.62,5.64,12.62,12.62s-5.65,12.62-12.62,12.62h-25.24c-6.97,0-12.62-5.64-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-23)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,332.92h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m236.32,355.06l-4.22-8.16c-1.49-2.9-2.86-5.71-4.14-8.41h-.06c.11,2.96.17,5.93.17,8.89v7.69h-3.19v-19.52h4.75l4.19,8.16c1.48,2.89,2.86,5.69,4.14,8.39h.06c-.1-3.29-.14-6.26-.14-8.89v-7.66h3.17v19.52h-4.72Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.41,340.7c1.39,0,2.59.31,3.61.92,1.03.6,1.83,1.44,2.39,2.55.57,1.11.86,2.42.86,3.92s-.29,2.8-.86,3.92c-.56,1.11-1.35,1.97-2.39,2.58-1.02.59-2.22.89-3.61.89s-2.63-.3-3.67-.89c-1.04-.61-1.83-1.47-2.39-2.58s-.83-2.42-.83-3.92.28-2.8.83-3.92,1.35-1.96,2.39-2.55c1.03-.61,2.26-.92,3.67-.92Zm0,2.47c-1.13,0-2.02.44-2.67,1.33-.63.87-.94,2.07-.94,3.58s.31,2.72.94,3.61c.65.87,1.53,1.31,2.67,1.31s1.98-.43,2.61-1.31c.65-.89.97-2.09.97-3.61s-.33-2.71-.97-3.58c-.63-.89-1.5-1.33-2.61-1.33Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.24,340.92c.37,0,.76.05,1.17.14v2.78c-.35-.07-.72-.11-1.11-.11-1.24,0-2.19.39-2.86,1.17s-1,1.89-1,3.33v6.83h-3.14v-13.94h2.92v2.06h.06c.92-1.5,2.25-2.25,3.97-2.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.25,352.67c.39,0,.7-.04.94-.14v2.44c-.56.17-1.14.25-1.75.25-1.49,0-2.55-.33-3.22-1s-1-1.76-1-3.28v-7.44h-2.33v-2.39h2.33v-3.47h3.14v3.47h2.69v2.39h-2.69v6.97c0,.78.14,1.35.42,1.69.29.33.78.5,1.47.5Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.13,342.75c.46-.65,1.04-1.14,1.75-1.47.7-.33,1.45-.5,2.25-.5,1.61,0,2.86.49,3.75,1.47.89.97,1.33,2.39,1.33,4.28v8.53h-3.14v-8.25c0-2.33-.94-3.5-2.83-3.5-.93,0-1.69.35-2.28,1.06-.6.69-.89,1.67-.89,2.94v7.75h-3.14v-19.52h3.14v7.22h.06Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.51,257.83c2.01,0,3.78.35,5.28,1.06,1.51.69,2.69,1.67,3.53,2.94.83,1.26,1.25,2.74,1.25,4.44s-.33,3.15-.97,4.39c-.63,1.22-1.5,2.28-2.61,3.17s-2.55,1.85-4.33,2.89c-1.91,1.11-3.35,2.07-4.33,2.86-.97.78-1.63,1.51-2,2.19-.37.69-.58,1.46-.61,2.31h15.55v4.36h-21.58c-.04-.24-.06-.56-.06-.94,0-2.03.23-3.78.69-5.22.48-1.46,1.34-2.84,2.58-4.14,1.26-1.31,3.07-2.65,5.44-4,1.68-.98,2.98-1.81,3.89-2.5.92-.7,1.62-1.46,2.11-2.28.5-.81.75-1.76.75-2.86,0-1.28-.41-2.29-1.22-3.05-.82-.78-1.94-1.17-3.36-1.17-3.32,0-5.05,1.76-5.19,5.28h-5.3c.09-3.11,1.06-5.51,2.92-7.19,1.85-1.68,4.37-2.53,7.58-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.33,257.83c2.01,0,3.78.35,5.28,1.06,1.51.69,2.69,1.67,3.53,2.94.83,1.26,1.25,2.74,1.25,4.44s-.33,3.15-.97,4.39c-.63,1.22-1.5,2.28-2.61,3.17s-2.55,1.85-4.33,2.89c-1.91,1.11-3.35,2.07-4.33,2.86-.97.78-1.63,1.51-2,2.19-.37.69-.58,1.46-.61,2.31h15.55v4.36h-21.58c-.04-.24-.06-.56-.06-.94,0-2.03.23-3.78.69-5.22.48-1.46,1.34-2.84,2.58-4.14,1.26-1.31,3.07-2.65,5.44-4,1.68-.98,2.98-1.81,3.89-2.5.92-.7,1.62-1.46,2.11-2.28.5-.81.75-1.76.75-2.86,0-1.28-.41-2.29-1.22-3.05-.82-.78-1.94-1.17-3.36-1.17-3.32,0-5.05,1.76-5.19,5.28h-5.3c.09-3.11,1.06-5.51,2.92-7.19,1.85-1.68,4.37-2.53,7.58-2.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m828.7,288.43v-6.3h5.86v6.3h-5.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848.34,289.1c-2.78,0-5.02-.76-6.72-2.28-1.71-1.53-2.67-3.64-2.89-6.33h5.33c.22,1.39.71,2.44,1.47,3.17.78.71,1.81,1.06,3.08,1.06,1.94,0,3.5-.83,4.67-2.5,1.18-1.68,1.81-4.23,1.89-7.64h-.08c-1.8,2.32-4.17,3.47-7.11,3.47-1.89,0-3.58-.42-5.05-1.25-1.46-.83-2.6-1.99-3.39-3.47-.8-1.48-1.19-3.18-1.19-5.11,0-2.03.45-3.84,1.36-5.42.9-1.57,2.17-2.79,3.8-3.67,1.62-.87,3.49-1.31,5.58-1.31,3.55,0,6.28,1.24,8.16,3.69,1.9,2.44,2.86,6.08,2.86,10.91,0,5.37-1.03,9.49-3.08,12.36-2.04,2.87-4.94,4.3-8.69,4.3Zm.67-15.19c1.57,0,2.84-.54,3.8-1.64.98-1.11,1.47-2.53,1.47-4.28s-.47-3.14-1.39-4.19c-.93-1.06-2.19-1.58-3.8-1.58s-2.92.53-3.86,1.58-1.42,2.49-1.42,4.28.46,3.19,1.39,4.25c.94,1.06,2.21,1.58,3.8,1.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.46,289.77l16.75-32.6h3.33l-16.75,32.6h-3.33Zm-.58-31.94c2.26,0,4,.75,5.22,2.25,1.24,1.49,1.86,3.6,1.86,6.36s-.62,4.89-1.86,6.39c-1.22,1.49-2.96,2.22-5.22,2.22s-3.99-.74-5.22-2.22c-1.22-1.5-1.83-3.62-1.83-6.39s.61-4.87,1.83-6.36c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.14c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.19.75,4.11c.5.91,1.22,1.36,2.17,1.36s1.69-.45,2.19-1.36c.5-.92.75-2.29.75-4.11s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.19-1.39Zm21.25,10.89c2.26,0,4,.75,5.22,2.25,1.24,1.5,1.86,3.63,1.86,6.39s-.62,4.86-1.86,6.36c-1.22,1.5-2.96,2.25-5.22,2.25s-3.99-.75-5.22-2.25c-1.22-1.5-1.83-3.62-1.83-6.36s.61-4.89,1.83-6.39c1.24-1.5,2.98-2.25,5.22-2.25Zm0,3.17c-.94,0-1.67.47-2.17,1.39-.5.91-.75,2.27-.75,4.08s.25,3.16.75,4.08c.5.91,1.22,1.36,2.17,1.36s1.72-.45,2.22-1.36c.5-.92.75-2.28.75-4.08s-.25-3.17-.75-4.08c-.5-.92-1.24-1.39-2.22-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 261.29,
    width: 252.44,
    height: 25.24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 509.57,
    y: 261.29,
    width: 58.06,
    height: 25.24,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-24)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m522.19,261.29h32.56c6.97,0,12.62,5.65,12.62,12.62s-5.65,12.62-12.62,12.62h-32.56c-6.97,0-12.62-5.65-12.62-12.62s5.65-12.62,12.62-12.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-25)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m509.57,261.29h252.44v25.24h-252.44v-25.24Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m237.67,283.43v-8.72h-9v8.72h-3.3v-19.52h3.3v7.94h9v-7.94h3.25v19.52h-3.25Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.58,269.08c1.87,0,3.28.47,4.25,1.39.98.91,1.47,2.27,1.47,4.08v5.22c0,1.5.12,2.72.36,3.67h-2.83c-.11-.57-.17-1.22-.17-1.94h-.06c-1.04,1.5-2.6,2.25-4.69,2.25-1.43,0-2.58-.39-3.44-1.17-.85-.78-1.28-1.76-1.28-2.97s.4-2.15,1.22-2.86c.81-.72,2.18-1.23,4.11-1.53,1.18-.2,2.44-.34,3.78-.42v-.56c0-.98-.25-1.7-.75-2.17-.49-.48-1.14-.72-1.97-.72s-1.52.22-2,.67c-.47.44-.72,1.04-.75,1.78h-3.08c.07-1.39.61-2.51,1.61-3.39,1-.89,2.4-1.33,4.22-1.33Zm2.72,7.75c-1.21.08-2.28.19-3.22.36-1,.17-1.71.42-2.14.75-.41.32-.61.8-.61,1.44,0,.61.21,1.11.64,1.5.44.37,1.06.56,1.83.56.5,0,.96-.07,1.39-.22.44-.17.82-.4,1.14-.72.37-.37.62-.76.75-1.19.15-.44.22-1.03.22-1.78v-.69Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.14,283.43v-13.94h3.14v13.94h-3.14Zm0-16.55v-2.97h3.14v2.97h-3.14Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.08,266.11c-.69,0-1.19.18-1.53.53-.33.35-.5.94-.5,1.75v1.11h2.69v2.39h-2.69v11.55h-3.08v-11.55h-2.36v-2.39h2.36v-1.47c0-1.42.35-2.5,1.06-3.22.72-.72,1.78-1.08,3.17-1.08.46,0,1.01.07,1.64.19v2.31c-.26-.07-.51-.11-.75-.11Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.36,269.08c1.87,0,3.28.47,4.25,1.39.98.91,1.47,2.27,1.47,4.08v5.22c0,1.5.12,2.72.36,3.67h-2.83c-.11-.57-.17-1.22-.17-1.94h-.06c-1.04,1.5-2.6,2.25-4.69,2.25-1.43,0-2.58-.39-3.44-1.17-.85-.78-1.28-1.76-1.28-2.97s.4-2.15,1.22-2.86c.81-.72,2.18-1.23,4.11-1.53,1.18-.2,2.44-.34,3.78-.42v-.56c0-.98-.25-1.7-.75-2.17-.49-.48-1.14-.72-1.97-.72s-1.52.22-2,.67c-.47.44-.72,1.04-.75,1.78h-3.08c.07-1.39.61-2.51,1.61-3.39,1-.89,2.4-1.33,4.22-1.33Zm2.72,7.75c-1.21.08-2.28.19-3.22.36-1,.17-1.71.42-2.14.75-.41.32-.61.8-.61,1.44,0,.61.21,1.11.64,1.5.44.37,1.06.56,1.83.56.5,0,.96-.07,1.39-.22.44-.17.82-.4,1.14-.72.37-.37.62-.76.75-1.19.15-.44.22-1.03.22-1.78v-.69Z",
    style: {
      fill: "#999"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics4);
export default __webpack_public_path__ + "static/media/infographics-4.4cd82add790550a82ae0b1d4077f9255.svg";
export { ForwardRef as ReactComponent };